import { useSuspenseQuery } from '@tanstack/react-query';

import { AGGREGATION_FIELDS } from '@/shared/api/openmetadata';
import { miscKeys } from '@/shared/lib/query/queryKeys';

import { fetchDataServices } from '@/features/data-services/api/dataServicesApi';

export const useDataServices = () => {
  return useSuspenseQuery({
    queryKey: miscKeys.dataServices(),
    queryFn: fetchDataServices,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    select: (response) => response.aggregations[AGGREGATION_FIELDS.SERVICE_TYPE].buckets,
  });
};
